import { render, staticRenderFns } from "./ItemListCard.vue?vue&type=template&id=088cde52&"
import script from "./ItemListCard.vue?vue&type=script&lang=js&"
export * from "./ItemListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports